export default __webpack_public_path__ + "static/media/enrollment-icon.a4223fa6.svg";